<style scoped>
.enquiry-form-input {
    border-color: #d52b1e;

    @apply px-4 py-1 border-2;
}
.enquiry-form-submit {
    color: rgba(255, 212, 90, 1);
    @apply outline-none bg-black;
}
.enquiry-form-submit:disabled {
    color: rgba(255, 212, 90, 1) !important;
    background-color: #bbbbbb !important;
}
.enquiry-form-submit:hover {
    background-color: rgba(255, 212, 90, 1);
    @apply text-darkGrayishBlue;
}
</style>

<template>
    <div>
        <component
            :is="formWrapper"
            class="text-darkGrayishBlue flex flex-col items-start contact-us-enquiry-form-wrapper"
        >
            <template v-if="success">
                <div class="py-4 w-full text-2xl">
                    {{ $t('about.us.enquiry.submit.success') }}
                </div>
            </template>
            <template v-else>
                <slot name="form" :form="enquiryForm" :errors="errors">
                    <div class="w-full mb-2">
                        <input
                            class="enquiry-form-input w-full"
                            :class="{
                                'enquiry-form-input-error': errors.contactName
                            }"
                            :placeholder="'Name'"
                            v-model.trim="enquiryForm.contactName"
                            maxlength="100"
                        />
                        <div class="text-red text-sm">
                            {{ $t(errors.contactName) }}
                        </div>
                    </div>
                    <div class="w-full mb-2">
                        <input
                            class="enquiry-form-input w-full"
                            :class="{
                                'enquiry-form-input-error': errors.contactEmail
                            }"
                            :placeholder="'Email'"
                            v-model.trim="enquiryForm.contactEmail"
                            maxlength="50"
                        />
                        <div class="text-red text-sm">
                            {{ $t(errors.contactEmail) }}
                        </div>
                    </div>
                    <div class="w-full mb-2">
                        <input
                            class="enquiry-form-input w-full"
                            :class="{
                                'enquiry-form-input-error': errors.contactPhone
                            }"
                            :placeholder="'Phone'"
                            type="tel"
                            v-model.trim="enquiryForm.contactPhone"
                            maxlength="50"
                        />
                        <div class="text-red text-sm">
                            {{ $t(errors.contactPhone) }}
                        </div>
                    </div>

                    <div class="w-full mb-2">
                        <textarea
                            class="enquiry-form-input w-full"
                            :class="{
                                'enquiry-form-input-error': errors.message
                            }"
                            :placeholder="'Type your message here...'"
                            v-model.trim="enquiryForm.message"
                            rows="5"
                            maxlength="1000"
                        />
                        <div class="text-red text-sm">
                            {{ $t(errors.message) }}
                        </div>
                    </div>
                </slot>

                <div
                    class="flex flex-wrap items-center w-full"
                    :class="submitBtnPanelClass"
                >
                    <recaptcha v-model="recaptchaKey" ref="recaptcha" />
                    <loadingButton
                        class="ml-auto text-xl px-6"
                        :class="submitBtnClass"
                        :status="postStatus"
                        @click="post"
                        :disabled="!recaptchaKey"
                        @successShown="postStatus = undefined"
                    >
                        {{ $t('about.us.enquiry.submit') }}
                    </loadingButton>

                    <div class="w-full mt-4">
                        <errorBox
                            class="text-sm self-start"
                            :message="errors.server"
                        />

                        <div
                            v-if="recaptchaError"
                            class="text-sm text-red self-start"
                        >
                            *reCAPTCHA verification expired. Please retry
                        </div>
                    </div>
                </div>
            </template>
        </component>
    </div>
</template>

<script>
import recaptcha from '@/components/recaptcha.vue';
import { validate } from '@/utils/validationUtil';
import { instance } from '@/utils/ajax';
import loadingButton from '@/components/loadingButton.vue';
import errorBox from '@/components/errorBox.vue';

export default {
    components: { recaptcha, loadingButton, errorBox },
    props: {
        formWrapper: { default: 'div' },
        submitBtnClass: {
            type: String,
            default: 'enquiry-form-submit border-0 rounded-none '
        },
        submitBtnPanelClass: { type: String }
    },
    data() {
        const u = this.$store.state.user;
        return {
            success: false,
            recaptchaKey: undefined,
            errors: {},
            postStatus: undefined,
            recaptchaError: false,
            enquiryForm: {
                contactName: u
                    ? `${u.custFrstName} ${u.custLastName} (${u.custId})`
                    : undefined,
                contactEmail: u?.custEmailAddr,
                contactPhone: u?.custPhoneNum,
                message: undefined
            }
        };
    },
    methods: {
        async post() {
            this.errors = {};
            this.recaptchaError = false;
            const v = validate(this.errors, this.enquiryForm, {
                contactName: { required: true },
                contactEmail: { required: true },
                contactPhone: { required: true },
                message: { required: true }
            });
            if (v.hasError) {
                this.errors = v.errors;
                return;
            }

            this.postStatus = 'loading';
            var result = await instance.post('/api/enq/gnrlEnq', {
                recaptchaKey: this.recaptchaKey,
                ...this.enquiryForm
            });

            if (result.data.success) {
                this.success = true;
                this.postStatus = 'success';
            } else {
                this.postStatus = undefined;
                if (result.data.data.recaptchaError) {
                    this.recaptchaError = true;
                    this.$refs.recaptcha.reset();
                }
                if (result.data.data.errors) {
                    this.errors = result.data.data.errors;
                }
            }
        }
    }
};
</script>
